/*后台账号&权限&配置数据接口*/

import {req} from "../utils/request";

export class Account {

  /**
   * 账号登录
   * @param params
   * @returns {Promise<any|undefined>}
   */
  login = async (params) => {
    return req.post('oauth/login', params);
  }

  /**
   * 账号登出
   * @param params
   * @returns {Promise<any|undefined>}
   */
  logout = async (params) => {
    return req.post('oauth/logout', params);
  }

  /**
   * 登录 角色的菜单
   * @param params
   * @returns {Promise<any|undefined>}
   */
  getMenuTree = async (params) => {
    return req.post('oauth/getMenuTree', params);
  }

  /**
   * 登录账号 修改个人信息
   * @param params
   * @returns {Promise<*|void>}
   */
  editLoginAdmin = async (params) => {
    return req.post('user/editLoginAdmin', params);
  }

  /**
   * 登录账号 修改密码
   * @param params
   * @returns {Promise<*|void>}
   */
  editLoginPwd = async (params) => {
    return req.post('user/editLoginPwd', params);
  }

  /**
   *  清除缓存
   * @param params
   * @returns {Promise<*|void>}
   */
  clearCache = async (params) => {
    return req.post('user/clearCache', params);
  }
}

export default new Account();